import { FC, useMemo } from 'react';
import Select from '../../select';
import { FormProps } from '../../helpers';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { getFormattedUiOptions } from '../../select/helpers';
import {
  getPublicServiceActionOptions,
  PublicServiceAction,
  PublicServiceConfig,
} from '@/lib/models/policy-model-v1/public-services';

interface Props extends FormProps {
  value: PublicServiceConfig;
  onChange: (value: PublicServiceConfig) => void;
  policy: PolicyModelV1;
  orgPolicy?: PolicyModelV1;
}

const PolicyPublicActionSelectV1: FC<Props> = ({
  value,
  onChange,
  policy,
  orgPolicy,
  ...rest
}) => {
  const handleChange = (optValue: string) => {
    const updated = {
      ...value,
      action: optValue as PublicServiceAction,
      allowPublicServicesByDefault: ['protected', 'monitored'].includes(optValue),
    };
    onChange(updated);
  };

  const serviceOpts = useMemo(() => {
    const options = getPublicServiceActionOptions(policy, orgPolicy);
    return getFormattedUiOptions(options);
  }, [policy, orgPolicy]);

  const { action } = value;

  const props = {
    ...rest,
    value: action,
    onChange: handleChange,
    options: serviceOpts,
    label: 'Default Service Action',
  };

  return <Select {...props} />;
};

export default PolicyPublicActionSelectV1;
